export default "__VITE_ASSET__C5Se6M_B__"